// import { useEffect } from "react";
import GameItem from "components/GameItem";
import { config } from '../Constants'
import { Box } from "@mui/material";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import DisplayProgressCircles from "components/DisplayProgressCircles";
import useFetchData from "helpers/useFetchData";

import "../styles/Games.css";
// import usePageSEO from "hooks/usePageSEO";


const Games = () => {
	const url = config.url.API_URL + 'games';
	const { data: items, loading, error, errorMessage } = useFetchData({ url });

	// useEffect(() => {
	// 	const title = 'Abdullah Ibne Alam - Games';
	// 	document.title = title;
	// 	const meta = document.createElement('meta');
	// 	meta.name = 'description';
	// 	meta.content = title;
	// 	document.head.appendChild(meta);
	// 	const metaUrl = document.createElement('meta');
	// 	metaUrl.name = 'og:url';
	// 	metaUrl.content = window.location.href;
	// 	document.head.appendChild(metaUrl);
	// 	const metaTitle = document.createElement('meta');
	// 	metaTitle.setAttribute('property', 'og:title');
	// 	metaTitle.content = title;
	// 	document.head.appendChild(metaTitle);
	// 	const metaDescription = document.createElement('meta');
	// 	metaDescription.setAttribute('property', 'og:description');
	// 	metaDescription.content = title;
	// 	document.head.appendChild(metaDescription);
	// 	const metaImage = document.createElement('meta');
	// 	metaImage.setAttribute('property', 'og:image');
	// 	metaImage.content = `${window.location.origin}/media/game/index.png`;
	// 	document.head.appendChild(metaImage);

	// 	return () => {
	// 	  document.head.removeChild(meta);
	// 	  document.head.removeChild(metaUrl);
	// 	  document.head.removeChild(metaTitle);
	// 	  document.head.removeChild(metaImage);
	// 	};
	//   }, []);

	// usePageSEO({
	// 	title: 'Abdullah Ibne Alam - Games',
	// 	description: 'Abdullah Ibne Alam - Games',
	// 	ogImage: [`${window.location.origin}/media/game/index.png`],
	// 	ogUrl: window.location.href,
	// 	ogType: 'portfolio'
	// });

	return (
		<div className="games">
			<meta property="title" content="Abdullah Ibne Alam - Games" />
			<meta property="description" content="Abdullah Ibne Alam - Games" />
			<meta property="og:title" content="Abdullah Ibne Alam - Games" />
			<meta property="og:description" content="Abdullah Ibne Alam - Games" />
			<meta property="og:image" content={`${window.location.origin}/media/game/index.png`} />
			<meta property="og:url" content={window.location.href} />
			{(loading || error) && (
			<Box sx={{ display: 'grid', placeItems: 'center', height: 'calc(100vh - 350px)'}}>
				{!error && (<DisplayProgressCircles />)}
				{error && (<div className="errorMsg">{errorMessage}</div>)}
			</Box>
			)}
			{(!loading && !!items && items.length) && (
			<div className="gameList">
				{items.map((item, index) => <GameItem key={index} game={item}  />)}

				{isMobile && (
				<Box sx={{ width: 'calc(100% - 10px)'}}>
					<Link to="/work" className="button" style={{ float: 'left'}}><span className="symbol prev">&laquo;</span> Work</Link>
					{/* <Link to="/" className="button" style={{ float: 'right'}}>Home <span className="symbol next">&raquo;</span></Link> */}
				</Box>
				)}
			</div>
			)}
		</div>
	);
}

export default Games;
